export default "__VITE_ASSET__CfHCmxnu__"